module.exports = __webpack_public_path__ + "img/button_download.dd9b11c5.jpg";